import { z } from "zod"

import { SearchGeographyKind } from "@/constants/terminal/search-geography-kind"
import type { SearchGeography } from "@/terminal/research/value-schemas"

export const StoredSearchGeographySchema = z.discriminatedUnion("kind", [
  z.object({ kind: z.literal(SearchGeographyKind.US) }).strict(),
  z
    .object({
      kind: z.literal(SearchGeographyKind.STATES),
      subdivision_codes: z.array(z.string()),
    })
    .strict(),
  z
    .object({
      kind: z.literal(SearchGeographyKind.COUNTIES),
      county_fips_codes: z.array(z.string()),
    })
    .strict(),
  z.object({ kind: z.literal(SearchGeographyKind.NOT_APPLICABLE) }).strict(),
])

export type StoredSearchGeography = z.infer<typeof StoredSearchGeographySchema>

export const parseStoredSearchGeography = (value: unknown) =>
  StoredSearchGeographySchema.parse(value)

export const storedSearchGeographyKey = (value: StoredSearchGeography) =>
  JSON.stringify(value)

export const storeSearchGeography = (
  geography: SearchGeography
): StoredSearchGeography => {
  switch (geography.kind) {
    case SearchGeographyKind.STATES:
      return {
        kind: geography.kind,
        subdivision_codes: geography.subdivisionCodes,
      }
    case SearchGeographyKind.COUNTIES:
      return {
        kind: geography.kind,
        county_fips_codes: geography.countyFipsCodes,
      }
    case SearchGeographyKind.US:
    case SearchGeographyKind.NOT_APPLICABLE:
      return { kind: geography.kind }
  }
}

export const loadSearchGeography = (
  geography: StoredSearchGeography
): SearchGeography => {
  switch (geography.kind) {
    case SearchGeographyKind.STATES:
      return {
        kind: geography.kind,
        subdivisionCodes: geography.subdivision_codes,
      }
    case SearchGeographyKind.COUNTIES:
      return {
        kind: geography.kind,
        countyFipsCodes: geography.county_fips_codes,
      }
    case SearchGeographyKind.US:
    case SearchGeographyKind.NOT_APPLICABLE:
      return { kind: geography.kind }
  }
}
